export default __webpack_public_path__ + "static/arindamLehri7-bd53e13234fb42603352d5e694cf299e.jpg";